// Every visitor-facing string goes through t(). English is the fallback for
// any key a language is missing, so a partial sv.json never shows a raw key.
import { config } from '../config.js';
import { storage } from '../util/storage.js';
import en from './en.json';
import sv from './sv.json';

const dicts = { en, sv };
const STORAGE_KEY = 'mw.language';
const listeners = new Set();

let current = storage.get(STORAGE_KEY) ?? config.language;
if (!dicts[current]) current = config.language;

export function t(key, vars = {}) {
  const raw = dicts[current]?.[key] ?? dicts.en[key] ?? key;
  return raw.replace(/\{(\w+)\}/g, (_, name) => String(vars[name] ?? `{${name}}`));
}

export function getLanguage() {
  return current;
}

export function getLanguages() {
  return config.languages.filter((code) => dicts[code]);
}

export function setLanguage(code) {
  if (!dicts[code] || code === current) return;
  current = code;
  storage.set(STORAGE_KEY, code);
  document.documentElement.lang = code;
  for (const fn of listeners) fn(code);
}

export function onLanguageChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

document.documentElement.lang = current;
